export function handleError(e, reject: Function) {
    let message = "Something went wrong";
    if (e.responseJSON) {
        let xhr: JQueryXHR = e;
        if (xhr.responseJSON instanceof Array && xhr.responseJSON.length > 0) {
            message = xhr.responseJSON.join("<br>");
        } else if (xhr.responseJSON && xhr.responseJSON.Message) {
            message = xhr.responseJSON.Message;
        } else if (xhr.statusText && xhr.statusText !== "error") {
            message = xhr.statusText;
        }
        reject(message);
    } else if (e instanceof Error) {
        reject(e);
    } else {
        reject(message);
    }
}





// WEBPACK FOOTER //
// ./Widget/services/ErrorHandling.ts